import React, { useCallback, useRef } from "react"
import { Appearance, TextInput, TouchableOpacity } from "react-native"
import { observer } from "mobx-react-lite"
import { Text } from "../text/text"
import { TxKeyPath, translate } from "../../i18n"
import { NumeralField } from "../field/numeral-field/numeral-field"
import { Formik } from "formik"
import * as yup from "yup"
import { FormProps } from "../form/form"
import { View, useDisclose } from "native-base"
import { JalaIcon } from "../jala-icon/jala-icon"
import { color } from "../../theme"
import Tooltip from 'react-native-walkthrough-tooltip';

export interface AutoFeederSetupNormalFormProps extends FormProps {
  colorScheme?: "light" | "dark",
  initialValues?: {
    debit?: number,
    onTime?: number,
    startTime?: string,
    endTime?: string,
    timesPerDay?: number,
    intervalPeriod?: number,
  },
}

export const InfoModal: React.FC<{ colorScheme?: "light" | "dark", title?: string }> = observer(function LogoutModal(props) {
  const { children, title } = props;
  const { isOpen, onClose, onOpen } = useDisclose()

  const contentTitle = title || translate("autoFeederPondCreateWizardScreen.timerOnInfo")
  return (<>
    <Tooltip
      isVisible={isOpen}
      content={<Text text={contentTitle} preset="body3" />}
      placement="bottom"
      onClose={onClose}
      showChildInTooltip={false}
    >
      <TouchableOpacity onPress={onOpen}>
        {children}
      </TouchableOpacity>
    </Tooltip>
  </>)
})

/**
 * Describe your component here
 */
export const AutoFeederSetupNormalForm = observer(function AutoFeederSetupNormalForm(props: AutoFeederSetupNormalFormProps) {
  const { initialValues = {}, colorScheme = "light" || Appearance.getColorScheme(), onSubmit,  innerRef, ...rest  } = props

  const input = {
    timesPerDay: useRef<TextInput>(),
    // debit: useRef<TextInput>(),
    intervalPeriod: useRef<TextInput>(),
    onTime: useRef<TextInput>(),
  }

  const nextInput = {
    timesPerDay: () => input.intervalPeriod.current && input.intervalPeriod.current.focus(),
    // debit: () => input.duration.current && input.duration.current.focus(),
    intervalPeriod: () => input.onTime.current && input.onTime.current.focus(),
  }

  const validationSchema = yup.object({
    timesPerDay: yup.number().moreThan(0).max(7).nullable().required().label(translate("autoFeederPondCreateWizardScreen.timesPerDay")),
    // debit: yup.number().nullable().required().label(translate("autoFeederPondCreateWizardScreen.debit")),
    intervalPeriod: yup.number().nullable().required().label(translate("autoFeederPondCreateWizardScreen.intervalPeriod")),
    onTime: yup.number().nullable().required().label(translate("autoFeederPondCreateWizardScreen.onTime")),
  })

  const unitElement = (type) => <View pr="8px">
    <Text text={translate(`autoFeederPondCreateWizardScreen.${type}Unit` as TxKeyPath)} preset="title4" color={color.palette.gray800} />
  </View>

  const labelComponentWithInfo = useCallback(() => {
    return (
        <InfoModal>
          <View flexDirection="row" alignItems="center">
            <Text tx="autoFeederPondCreateWizardScreen.onTime" preset="title4" colorScheme={colorScheme} mr="6px" />
            <JalaIcon name="info-1" size={16} color={color.palette.gray800} />
          </View>
        </InfoModal>
    )
  }, [colorScheme])

  return (
    <Formik
      initialValues={{ ...initialValues }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      innerRef={innerRef}
      {...rest}
    >
    {({ isValid, handleSubmit, values, initialValues }) => (
      <>
        <NumeralField
          name="timesPerDay"
          txPrefix="autoFeederPondCreateWizardScreen"
          colorScheme={colorScheme}
          input={input}
          nextInput={nextInput}
          formControlProps={{
            style: { paddingHorizontal: 0 },
            inputProps: { placeholder: '-', InputRightElement: unitElement('timesPerDay') }
          }}
        />
        {/* <NumeralField
          name="debit"
          txPrefix="autoFeederPondCreateWizardScreen"
          colorScheme={colorScheme}
          input={input}
          nextInput={nextInput}
          formControlProps={{
            style: { paddingHorizontal: 0 },
            inputProps: { placeholder: '-', InputRightElement: unitElement('debit') }
          }}
        /> */}
        <NumeralField
          name="intervalPeriod"
          txPrefix="autoFeederPondCreateWizardScreen"
          colorScheme={colorScheme}
          input={input}
          nextInput={nextInput}
          formControlProps={{
            style: { paddingHorizontal: 0 },
            inputProps: { placeholder: '-', InputRightElement: unitElement('intervalPeriod') }
          }}
        />
        <NumeralField
          name="onTime"
          txPrefix="autoFeederPondCreateWizardScreen"
          colorScheme={colorScheme}
          input={input}
          nextInput={nextInput}
          formControlProps={{
            labelComponent: labelComponentWithInfo(),
            style: { paddingHorizontal: 0 },
            inputProps: { placeholder: '-', InputRightElement: unitElement('onTime') },
          }}
        />
      </>
    )}
    </Formik>
  )
})
